import { render, staticRenderFns } from "./SettingsButton.vue?vue&type=template&id=a1264000&scoped=true&"
import script from "./SettingsButton.vue?vue&type=script&lang=js&"
export * from "./SettingsButton.vue?vue&type=script&lang=js&"
import style0 from "./SettingsButton.vue?vue&type=style&index=0&id=a1264000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1264000",
  null
  
)

component.options.__file = "SettingsButton.vue"
export default component.exports